<template>
    <div>
      <b-card>
        <b-row>
              <b-col sm='2' v-for="photo in photo_list" :key="photo.id">
                <div style="background-color: #eee;padding:7px;border-radius: 10px;">
                  <b-img-lazy thumbnail fluid :src="photo.url"/>
                  <div style="font-size:12px;color:#999;text-align: center;">{{ photo.created_at }}</div>
                  <b-form-input id="lesson"  placeholder="學生編號" v-model="photo.student_code" size="sm" class="mb-1"/>
                  <b-row>
                    <b-col sm="8"><b-button class="text-center" block size="sm" variant="primary" style="font-size:11px;" @click="submit(photo.id,photo.student_code)">確認</b-button></b-col>
                    <b-col sm="4">
                      <b-button
                        variant="gradient-danger"
                        class="btn-icon rounded-circle"
                        size="sm"
                        @click="delete_photo(photo.id)"
                      >
                        <feather-icon icon="Trash2Icon" size="10"/>
                      </b-button>

                    </b-col>
                  </b-row>
                </div>
                 
              </b-col>      
            </b-row>
      </b-card>
  </div>
</template>

<script>
import { BForm, BFormGroup, BFormInput, BRow, BCol, BButton,BCard,BFormCheckbox,BImg,BImgLazy,BInputGroup,
    BInputGroupAppend,
    BInputGroupPrepend } from 'bootstrap-vue'
import BCardCode from '@core/components/b-card-code'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
export default {
  components: {
    BCardCode,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroupPrepend,
    BImg,
      BImgLazy,
    BForm,
    BCard,
    BFormCheckbox,
    vSelect,
    BRow,
    BCol,
    ToastificationContent,
    BButton,
    BFormGroup,
    BFormInput,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
        photo_list : []
    }
  },

  watch: {
    
  },
  created() {
    this.get_photos()
  },

  methods: {
      submit(id,student_code) {
          this.$http.post(process.env.VUE_APP_API_BASE+"/album/tag/",{ id:id,student_code:student_code })
        .then(res => {
            if (res.data.result === true) {
              this.get_photos()
                this.$toast({
                  component: ToastificationContent,
                  position: 'top-right',
                  props: {
                    title: 'Success',
                    icon: 'CheckIcon',
                    variant: 'success',
                    text: res.data.message,
                  },
                })
            }
        })
      },
      delete_photo(id) {
          this.$http.post(process.env.VUE_APP_API_BASE+"/album/delete/",{ id:id })
        .then(res => {
            if (res.data.result === true) {
              this.get_photos()
                this.$toast({
                  component: ToastificationContent,
                  position: 'top-right',
                  props: {
                    title: 'Success',
                    icon: 'CheckIcon',
                    variant: 'success',
                    text: res.data.message,
                  },
                })
            }
        })
      },
      get_photos() {
      this.$http.get(process.env.VUE_APP_API_BASE+`/album/untagged/`+this.$store.getters['center/currentCenterId'] +`/`)
        .then(res => {
          this.photo_list = res.data.photos
        })
    },
  },
}
</script>

<style lang="scss" scoped>

</style>
